import { Box, Stack } from '@mui/system'
import { FC } from 'react'
import {
  EngagementFinalizedActivityResult,
  FinalDocumentationActivity as FinalDocumentationActivityModel,
  OutdoorEngagement,
  PeopleObservedRemainedInCameraView,
  ProcessedActivity
} from '../../../../../../api/models'
import { ActivityTimingResult } from '../useActivityTiming'
import { ActivityFieldBox } from '../ActivityFieldBox'
import { FIELD_LABEL_PEOPLE_OBSERVED } from '../ActivityCard.constants'
import { EqualColumnsGrid } from '../../EqualColumnsGrid'
import { SharedActivity } from './SharedActivity'

interface FinalDocumentationActivityProps {
  activity: Extract<ProcessedActivity, FinalDocumentationActivityModel>
  engagement: OutdoorEngagement
  timing: ActivityTimingResult
}

export const FinalDocumentationActivity: FC<FinalDocumentationActivityProps> = ({ activity, engagement, timing }) => {
  const result = activity.completed?.result as unknown as EngagementFinalizedActivityResult | undefined
  const selectedImages = result?.relevantImages?.filter(image => image.wasSelected).length || 0
  const remainedInView = result?.peopleObserved?.remainedInCameraView === PeopleObservedRemainedInCameraView.RemainedInCameraView ? 'Yes' : 'No'

  return (
    <Stack direction="column" sx={{ gap: 'var(--spacing-2xs)' }}>
      <SharedActivity activity={activity} engagement={engagement} timing={timing} />
      <EqualColumnsGrid>
        <ActivityFieldBox label="Remained in View">
          <Box>{remainedInView}</Box>
        </ActivityFieldBox>
        <ActivityFieldBox label={FIELD_LABEL_PEOPLE_OBSERVED}>
          <Box data-testid="activity-card-people-observed-value">{result?.peopleObserved?.numberOfPeopleObserved ?? 0}</Box>
        </ActivityFieldBox>
        <ActivityFieldBox label="Relevant Images">
          <Box>{selectedImages}</Box>
        </ActivityFieldBox>
      </EqualColumnsGrid>
      {result?.internalNote?.value && (
        <ActivityFieldBox label="Specialist Internal Note">
          <Box data-testid="activity-card-internal-note-value">{result?.internalNote?.value}</Box>
        </ActivityFieldBox>
      )}
    </Stack>
  )
}
